
import { ResponseType } from './response.type';

export const showResponse = (data) => ({
  type: ResponseType.showResponse,
  payload: data
  
});
export const showDashBoardResponse = (data) => ({
  type: ResponseType.showDashBoardResponse,
  payload: data
  
});


export const setMoneyTransferResponse = (data) => ({
  type: ResponseType.setMoneyTransferResponse,
  payload: data
  
});


//showUserProfileResponse
export const showCreateOrderResponse = (data) => ({
  type: ResponseType.showCreateOrderResponse,
  payload: data
  
});

export const showCreateOrderResponseArr = (data) => ({
  type: ResponseType.showCreateOrderResponseArr,
  payload: data
  
});


//showUserProfileResponse
export const showUserProfileResponse = (data) => ({
  type: ResponseType.showUserProfileResponse,
  payload: data
  
});

//showAdminProfileResponse
export const showAdminProfileResponse = (data) => ({
  type: ResponseType.showAdminProfileResponse,
  payload: data
  
});
export const showUserResponse = (data) => ({
  type: ResponseType.showUserResponse,
  payload: data
  
});
export const showWalletResponse = (data) => ({
  type: ResponseType.showWalletResponse,
  payload: data
  
});

//recharge

export const showCreateOrderResponse1 = (data) => ({
  type: ResponseType.showCreateOrderResponse1,
  payload: data
  
});

export const resetResponse ={
  type: ResponseType.RESET
}